import { css } from '@linaria/core';

import type { Table } from '../../sanity/sanity.types';

const tableClass = css`
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
`;
export const BlockTable = ({ value }: { value?: Table }) => {
	if (!value || !Array.isArray(value.rows) || value.rows.length === 0) {
		return null;
	}

	const [head, ...rows] = value.rows;

	if (!head || !Array.isArray(head.cells)) {
		return null;
	}

	return (
		<div className={tableClass}>
			<table>
				<thead>
					<tr>
						{head.cells.map((cell) => (
							<th key={cell}>{cell}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((row, rowIndex) => (
						<tr key={row._key || rowIndex}>
							{Array.isArray(row.cells)
								? row.cells.map((cell, cellIndex) => {
										const Component = cellIndex === 0 ? 'th' : 'td';
										return <Component key={cellIndex}>{cell}</Component>;
								  })
								: null}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
